import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            minHeight: '90%',
        },
        dialogPaper: {
            minHeight: '90vh',
            maxHeight: '90vh',
        },
        tabs: {
            flexGrow: 1,
            position: 'relative',
        },
        tabPane: {
            flexGrow: 1,
        },
        descriptionItem: {
            marginBottom: theme.spacing(3),
        },
        editButton: {
            position: 'absolute',
            right: 20,
            top: 20,
        },
    })
);
